import React from 'react';
import { showInfo } from '@utils';
import { CopyIcon } from 'components/common/ui/Vectors';
import IconButtonV2 from 'components/common/ui/IconButtonV2/IconButtonV2';

import styles from './instaTaskSidebarCopyItem.styles';

const InstaTaskSidebarCopyItem = ({ value }) => {
  if (!value || value === '-') return null;

  const handleCopyValue = (valueToCopy) => {
    navigator.clipboard.writeText(valueToCopy);
    showInfo('Copied to clipboard', 'copied', 1000);
  };

  return (
    <IconButtonV2
      variant="text"
      sx={styles.copyButton}
      onClick={() => handleCopyValue(value)}
    >
      <CopyIcon />
    </IconButtonV2>
  );
};

export default InstaTaskSidebarCopyItem;
